module.exports = __webpack_public_path__ + "static/media/iconeFacebook.2a9511a6.svg";